import { z } from 'zod';

export const zodDeliveryNoteAttachmentAdminSearchParamsSchema = z
  .object({
    digest: z.string().trim().optional(),
    name: z.string().trim().optional(),
  })
  .refine((data) => Boolean(data.digest) || Boolean(data.name), {
    path: ['digest', 'name'],
    error: 'Either digest or name must be provided',
  });

export const zodDeliveryNoteAttachmentAdminEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('asset'),
  z.literal('delivery_note'),
  z.uuid(),
  z.literal('attachment'),
]);
